module.exports = __webpack_public_path__ + "img/img_osez_transformation_industrie.370891a2.png";